module.exports = __webpack_public_path__ + "img/38.0cacb21b.png";